import { enUS, ptBR, fr, de, es, arEG, nl, id } from 'date-fns/locale';

export const dateFnsLocales = {
  en: enUS,
  'pt-BR': ptBR,
  fr,
  de,
  'es-MX': es,
  'ar-EG': arEG,
  nl,
  id,
};
